export enum CpStatus {
    ONLINE = 'Online',
    OFFLINE = 'Offline',
    AVAILABLE = "Available"
}